import { useEffect, useReducer } from "react";
import translate from "@/i18n/translate";
import { useFormatMessage } from "@/features/common/helper";
import { OutcomesTerminology } from "@/contexts/AppContext";
import { sendRequest } from "@/common/http";

interface InitialState {
  outcomesTerminology: OutcomesTerminology | null;
}

type DefaultAction = {
  type: "setOutcomesTerminology";
  data: OutcomesTerminology | null;
};

const initialState: InitialState = {
  outcomesTerminology: null
};

const reducer = (state: InitialState, action: DefaultAction): InitialState => {
  switch (action.type) {
    case "setOutcomesTerminology":
      return { ...state, outcomesTerminology: action.data };
    default:
      return state;
  }
};

const EmptyStateSll = () => {
  const formatMessage = useFormatMessage();
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const applyResult = (result: OutcomesTerminology) => {
      if (result) {
        dispatch({ type: "setOutcomesTerminology", data: result });
      }
    };
    sendRequest({ uri: "/outcomes-terminology", camelize: true }, applyResult);
  }, []);

  return (
    <div className="wm-grid-row student-learning-assesment empty-state-sll ">
      <span
        className="sr-only faculty-loader-status"
        role="status"
        aria-live="assertive"
      ></span>
      <div className="grid-container wm-grid-col-12 wm-grid-col-md-10">
        <div className="paper-card paper-card-height">
          <div className="header">
            <div className="info">
              <h3 className="title">
                {translate("app.studentLearningAssesment.insightsComingSoon")}
              </h3>
            </div>
          </div>
          <div id="insights-coming-soon" className="empty-state-content">
            <div className="continuous-improvement-insights">
              <DataSaveroffIcon />
              <div className="sub-header">
                {translate("app.continuousImprovement.title")}
              </div>
              <div className="desc">
                {translate(
                  "app.studentLearningAssesment.continuousInsightsDesc"
                )}
              </div>
            </div>
            <div className="organization-strategy-insights">
              <VectorIcon />
              <div className="sub-header">
                {translate("app.studentLearningAssesment.organizationInsights")}
              </div>
              <div className="desc">
                {translate(
                  "app.studentLearningAssesment.organizationInsightsDesc"
                )}
              </div>
            </div>
            <div className="student-success-insights">
              <AreaChartIcon />
              <div className="sub-header">
                {translate("app.studentLearningAssesment.studentInsights")}
              </div>
              <div className="desc">
                {formatMessage(
                  { id: "app.studentLearningAssesment.studentInsightsDesc" },
                  {
                    success_outcome_singular:
                      state.outcomesTerminology?.successOutcomes?.singular ||
                      "..."
                  }
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
function DataSaveroffIcon() {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.9163 4.21875V10.5312C15.8538 11.5521 10.4163 17.5937 10.4163 24.9479C10.4163 26.8229 10.7913 28.5937 11.4163 30.2396L5.99968 33.4271C4.83301 30.8437 4.16634 27.9687 4.16634 24.9479C4.16634 14.1562 12.3955 5.26042 22.9163 4.21875ZM24.9997 39.5312C33.0622 39.5312 39.583 33.0104 39.583 24.9479C39.583 17.5937 34.1455 11.5521 27.083 10.5312V4.21875C37.6247 5.26042 45.833 14.1354 45.833 24.9479C45.833 36.4479 36.5205 45.7812 25.0205 45.7812C18.1247 45.7812 12.0205 42.4271 8.22884 37.2604L13.6455 34.0729C16.3122 37.4062 20.3955 39.5312 24.9997 39.5312Z"
        fill="#6B6B6B"
      />
    </svg>
  );
}

function VectorIcon() {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10 12.5H0V40H10V12.5Z" fill="#6B6B6B" />
      <path d="M10 0H0V10H10V0Z" fill="#6B6B6B" />
      <path d="M25 7.5H15V17.5H25V7.5Z" fill="#6B6B6B" />
      <path d="M40 15H30V25H40V15Z" fill="#6B6B6B" />
      <path d="M40 27.5H30V40H40V27.5Z" fill="#6B6B6B" />
      <path d="M25 20H15V40H25V20Z" fill="#6B6B6B" />
    </svg>
  );
}

function AreaChartIcon() {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.5 10.75L23 0.75L10.5 18.25L0.5 10.75V43.25H45.5V10.75H35.5ZM40.5 35.625L23 22L13 35.75L5.5 29.75V20.75L11.6 25.325L24 7.95L33.75 15.75H40.5V35.625Z"
        fill="#6B6B6B"
      />
    </svg>
  );
}
export default EmptyStateSll;
